/**
 * Aseli Offer Header — copy-to-clipboard for CouponCode chips ([data-coupon-code]).
 * Progressive enhancement: without JS the code remains visible/selectable.
 * Idempotent (data-acc-bound guard) + shopify:section:load support.
 */
(function () {
  function bind(btn) {
    if (btn.getAttribute('data-acc-bound')) return;
    btn.setAttribute('data-acc-bound', '1');
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-coupon-code') || '';
      if (!code) return;
      var showCopied = function () {
        btn.classList.add('is-copied');
        window.setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(showCopied);
      } else {
        // Fallback: temporary selected textarea + execCommand.
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        showCopied();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-coupon-code]').forEach(bind);
  }
  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      event.target.querySelectorAll('[data-coupon-code]').forEach(bind);
    }
  });
})();
